import { render, staticRenderFns } from "./ecas.vue?vue&type=template&id=2c10f5cc&"
import script from "./ecas.vue?vue&type=script&lang=js&"
export * from "./ecas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports